// Shared config for the DRP Client Feedback & Discharge Interview form + print.

export const DRP_LIKERT_LEGEND = [
  { n: 1, label: "Strongly Disagree / Very Dissatisfied" },
  { n: 2, label: "Disagree / Dissatisfied" },
  { n: 3, label: "Neutral" },
  { n: 4, label: "Agree / Satisfied" },
  { n: 5, label: "Strongly Agree / Very Satisfied" },
];

export const DRP_SECTIONS = [
  {
    title: "Section 1: Admission & Registration Process",
    questions: [
      { key: "s1_1", label: "The admission and registration process was easy to understand." },
      { key: "s1_2", label: "The information provided during registration was clear and helpful." },
      { key: "s1_3", label: "I received adequate guidance during the registration process." },
      { key: "s1_4", label: "The front desk staff treated me respectfully and professionally." },
      { key: "s1_5", label: "The front desk staff communicated clearly and effectively." },
      { key: "s1_6", label: "My questions were answered satisfactorily during registration." },
      { key: "s1_7", label: "Overall, I was satisfied with the admission and registration process." },
    ],
  },
  {
    title: "Section 2: Care, Treatment & Recovery Plan",
    questions: [
      { key: "s2_1", label: "I was actively involved in developing my Individual Recovery Plan (IRP)." },
      { key: "s2_2", label: "My recovery plan reflected my personal needs and goals." },
      { key: "s2_3", label: "I received adequate support to achieve my recovery goals." },
      { key: "s2_4", label: "My IRP was reviewed regularly with me." },
      { key: "s2_5", label: "The treatment services remained focused on my recovery needs." },
      { key: "s2_6", label: "I understood the goals and objectives of my treatment plan." },
    ],
  },
  {
    title: "Section 3: PRP (Case Manager) Services",
    questions: [
      { key: "s3_1", label: "My PRP demonstrated professionalism and respect." },
      { key: "s3_2", label: "My PRP communicated clearly and effectively." },
      { key: "s3_3", label: "My PRP was available when I needed assistance." },
      { key: "s3_4", label: "My PRP provided appropriate guidance and support." },
      { key: "s3_5", label: "I was satisfied with the services provided by my PRP." },
      { key: "s3_6", label: "My PRP helped me progress toward my recovery goals." },
    ],
  },
  {
    title: "Section 4: Group Sessions & Outcomes",
    questions: [
      { key: "s4_1", label: "Group sessions were beneficial to my recovery." },
      { key: "s4_2", label: "Group sessions helped me develop useful coping skills." },
      { key: "s4_3", label: "I felt engaged during group sessions." },
      { key: "s4_4", label: "The facilitators encouraged participation." },
      { key: "s4_5", label: "I was satisfied with the quality of group sessions." },
    ],
  },
  {
    title: "Section 5: Nursing & Medication Services",
    questions: [
      { key: "s5_1", label: "Nursing staff treated me with respect and professionalism." },
      { key: "s5_2", label: "Nursing staff communicated clearly regarding my care." },
      { key: "s5_3", label: "I was satisfied with nursing services." },
      { key: "s5_4", label: "Medication instructions were clearly explained." },
      { key: "s5_5", label: "The purpose of prescribed medications was explained to me." },
      { key: "s5_6", label: "Potential medication side effects were explained to me." },
      { key: "s5_7", label: "I was satisfied with medication dispensing services." },
    ],
  },
  {
    title: "Section 6: Doctor / Psychiatrist Services",
    questions: [
      { key: "s6_1", label: "The doctor/psychiatrist treated me with dignity and respect." },
      { key: "s6_2", label: "The doctor/psychiatrist explained my treatment clearly." },
      { key: "s6_3", label: "I had sufficient opportunity to ask questions." },
      { key: "s6_4", label: "The doctor/psychiatrist listened to my concerns." },
      { key: "s6_5", label: "I was satisfied with my consultations." },
    ],
  },
  {
    title: "Section 7: Environment & Support Services",
    questions: [
      { key: "s7_1", label: "Housekeeping staff behaved professionally and respectfully.", subheading: "Housekeeping" },
      { key: "s7_2", label: "The facility was clean and hygienic." },
      { key: "s7_3", label: "I was satisfied with housekeeping services." },
      { key: "s7_4", label: "Maintenance staff behaved professionally and respectfully.", subheading: "Maintenance" },
      { key: "s7_5", label: "Maintenance issues were addressed promptly." },
      { key: "s7_6", label: "I was satisfied with maintenance services." },
      { key: "s7_7", label: "I felt safe and secure while attending the programme.", subheading: "Safety" },
      { key: "s7_8", label: "The facility provided a supportive recovery environment." },
    ],
  },
  {
    title: "Section 8: Kitchen & Meal Services",
    questions: [
      { key: "s8_1", label: "Kitchen staff behaved professionally and respectfully." },
      { key: "s8_2", label: "I was satisfied with kitchen services." },
      { key: "s8_3", label: "The menu offered sufficient variety." },
      { key: "s8_4", label: "The quality of meals was satisfactory." },
      { key: "s8_5", label: "Meal timing and availability met my needs." },
    ],
  },
  {
    title: "Section 9: Dignity, Privacy & Communication",
    questions: [
      { key: "s9_1", label: "I trusted the healthcare team involved in my care." },
      { key: "s9_2", label: "I was treated with dignity and respect." },
      { key: "s9_3", label: "My confidentiality and privacy were maintained." },
      { key: "s9_4", label: "Staff listened carefully to my concerns." },
      { key: "s9_5", label: "I felt comfortable communicating with staff." },
      { key: "s9_6", label: "I felt free to ask questions whenever needed." },
      { key: "s9_7", label: "Staff responded appropriately to my concerns." },
    ],
  },
  {
    title: "Section 10: Client Involvement",
    questions: [
      { key: "s10_1", label: "I was involved in decisions regarding my care and treatment." },
      { key: "s10_2", label: "Staff encouraged my participation in treatment planning." },
      { key: "s10_3", label: "My opinions and preferences were respected." },
    ],
  },
  {
    title: "Section 11: Discharge Planning",
    questions: [
      { key: "s11_1", label: "I received adequate discharge planning." },
      { key: "s11_2", label: "The duration of treatment was appropriate for my needs." },
      { key: "s11_3", label: "I understood my discharge plan." },
      { key: "s11_4", label: "I felt prepared for continuing recovery after discharge." },
    ],
  },
  {
    title: "Section 12: Transition & Follow-up",
    questions: [
      { key: "s12_1", label: "I was satisfied with the discharge information provided." },
      { key: "s12_2", label: "Follow-up instructions were clearly explained." },
      { key: "s12_3", label: "Emergency contact information was provided." },
      { key: "s12_4", label: "I understand how to access support after discharge." },
    ],
  },
  {
    title: "Section 13: Overall Experience",
    questions: [
      { key: "s13_1", label: "Overall, I was satisfied with the DRP services." },
      { key: "s13_2", label: "The programme met my recovery needs." },
      { key: "s13_3", label: "I would recommend TRH's DRP services to others." },
      { key: "s13_4", label: "I would return to TRH for services if needed in the future." },
      { key: "s13_5", label: "My experience at TRH contributed positively to my recovery." },
    ],
  },
];

export const DRP_LIKERT_KEYS = DRP_SECTIONS.flatMap((s) => s.questions.map((q) => q.key));
